const landing = {
    hero: {
        title: 'Boek unieke ervaringen in Abruzzo',
        subtitle: 'Ontdek de schoonheid van Italië\'s verborgen juweel',
        cta: 'BEGIN NU'
    },
    trips: {
        title: 'Onze Reizen',
        subtitle: 'Verken onze gecureerde ervaringen',
        summerTrip: {
            title: 'Zomeravontuur',
            description: 'Beleef het beste van Abruzzo in de zomer',
            price: 'Vanaf €299'
        },
        winterTrip: {
            title: 'Winterlandschap',
            description: 'Ontdek de wintermagie van Abruzzo',
            price: 'Vanaf €399'
        }
    },

    tripStatus: {
        comingSoon: 'De reis zal binnenkort beschikbaar zijn, blijf op de hoogte ❤️'
    },
    destinations: {
        title: 'Populaire Bestemmingen',
        subtitle: 'Plekken die je niet mag missen in Abruzzo',
        roccaCalascio: {
            title: 'Rocca Calascio',
            description: 'Het dorp in de wolken'
        },
        collaltoSabino: {
            title: 'Collalto Sabino',
            description: 'Het middeleeuwse dorp van Sabina'
        },
        santoStefanoDiSessanio: {
            title: 'Santo Stefano di Sessanio',
            description: 'Het middeleeuwse juweel van Gran Sasso'
        },
        trabocchiCoast: {
            title: 'Trabocchi Kust',
            description: 'De betoverde kust van de trabocchi'
        },
        campoImperatore: {
            title: 'Campo Imperatore',
            description: 'Het Kleine Tibet van Abruzzo'
        },
        scanno: {
            title: 'Scanno',
            description: 'Het Dorp van Juweel en het Meer'
        }
    },
    activities: {
        title: 'Blader door Activiteiten',
        subtitle: 'Het avontuur wacht op je in Abruzzo', deerWatching: {
            title: 'Wild Life Spotting',
            description: 'Ontdek wildlife in het nationaal park'
        },
        wineTasting: {
            title: 'Wijnproeverij',
            description: 'Proef lokale wijnen en typische producten'
        },
        arrosticiniMucciante: {
            title: 'Arrosticini Mucciante',
            description: 'De Abruzzo culinaire traditie'
        },
        sextantio: {
            title: 'Sextantio',
            description: 'Het verspreide hotel van het dorp'
        }
    },
    curiosities: {
        title: 'Curiositeiten',
        subtitle: 'Ontdek de geheimen van Abruzzo',
        wildlife: {
            title: 'Wildlife',
            description: 'Het wildlife van Abruzzo'
        },
        gastronomy: {
            title: 'Gastronomie',
            description: 'De authentieke smaken van Abruzzo'
        },
        history: {
            title: 'Geschiedenis'
        }
    },
    products: {
        title: 'Onze Producten',
        subtitle: 'Ontdek de authentieke smaken van Abruzzo met onze selectie van typische producten',
        viewAll: 'Bekijk Alle Producten',
        moreComingSoon: 'Meer producten komen binnenkort'
    },
    footer: {
        about: 'Over Ons',
        contact: 'Contact',
        privacy: 'Privacy',
        terms: 'Algemene Voorwaarden',
        companyDescription: 'Unieke ervaringen in Abruzzo. Ontdek de schoonheid van natuur, dorpen en Italiaanse cultuur.',
        quickLinks: 'Snelle Links',
        followUs: 'Volg Ons',
        followUsDescription: 'Blijf op de hoogte van onze laatste ervaringen en speciale aanbiedingen.',
        copyright: '© 2025 La Dolce Vita Reis. Alle rechten voorbehouden.',
        cookiePolicy: 'Cookiebeleid',
        manageCookies: 'Beheer Cookies',
        creativeCommons: 'Afbeeldingen gelicentieerd onder Creative Commons — ',
        fullCredits: 'volledige credits hier.'
    },
    cookieBanner: {
        title: '🍪 We gebruiken cookies',
        description: 'We gebruiken cookies voornamelijk voor analyses en om je ervaring te verbeteren. Systeemcookies worden automatisch geaccepteerd. Door te accepteren, stem je in met het gebruik van deze cookies. Je kunt je voorkeuren beheren of meer leren over ons cookiebeleid.',
        privacyPolicy: 'Privacybeleid',
        termsAndConditions: 'Algemene Voorwaarden',
        acceptAll: 'Alles Accepteren',
        rejectAll: 'Alles Weigeren',
        managePreferences: 'Beheer Voorkeuren'
    },
    cookieModal: {
        title: '🍪 Beheer Cookie Voorkeuren',
        necessaryCookies: 'Noodzakelijke Cookies',
        alwaysActive: 'Altijd Actief',
        necessaryDescription: 'Deze cookies zijn essentieel voor de werking van de website en kunnen niet worden uitgeschakeld.',
        analyticsCookies: 'Analytische Cookies',
        analyticsDescription: 'Deze cookies helpen ons de site te verbeteren door te analyseren hoe deze wordt gebruikt.',
        moreInfo: 'Je kunt je voorkeuren op elk moment wijzigen. Voor meer informatie, zie ons',
        cookiePolicy: 'Cookiebeleid',
        savePreferences: 'Voorkeuren Opslaan',
        acceptAll: 'Alles Accepteren',
        rejectAll: 'Alles Weigeren',
        cancel: 'Annuleren'
    }
};

export default landing;

